import request from '../request/http';

//手机验证码登录

export function getloginCode(data) {    
  return request({
    url: '/yunxue_co_api/login/loginBySMS?phone='+data.phone+"&identCodeSMS="+data.identCodeSMS+"&deviceId="+data.deviceId+"&deviceToken="+data.deviceToken,
    method: 'post',
    data: data
  })
}

/**
 * 获取验证码
 */
 export function getCode(data) {
  return request({
    url: '/yunxue_co_api/login/sendSMS/' + data.phone + '/' + data.token + '/' + data.secrect + '/',
    method: 'get',
    params: data
  })

}


//密码登录
export function getloginPass(data) {
  return request({
    url: '/yunxue_co_api/login/loginByPwd?phone='+data.phone+"&pwd="+data.pwd,
    method: 'post',
    data: data
  })

  
}

/**
 * 获取企业
 */
export function getQiyes(data) {
  return request({
    url: '/yunxue_co_api/company/getAllCompany',
    method: 'get',
    params: data
  })

}

/**
 * 切换所有公司
 * 
 */
export function changeQiyes(data) {
	return request({
    url: '/yunxue_co_api/company/updateMainCompany',
    method: 'get',
    params: data
  })
}

/**
 * 获取用户信息
 */
 export function getUserInfo(data) {
  return request({
    url: '/yunxue_co_api/user/getUserMessage',
    method: 'get',
    params: data,
    isJson: true
  })
}

/**
 * 文档列表
 */
export function getDocumentList(data) {
  return request({
    url: '/yunxue_co_api/document/getFolderList',///yunxue_co_api/document/getFolderListRole
    method: 'get',
    params: data,
    isJson: true
  })
}




/**
 * 文档树
 */
export function getDocumentTree(data) {
  return request({
    url: '/yunxue_co_api/document/getDirs',
    method: 'get',
    params: data,
    isJson: true
  })
}



/**
 * 登录选择课程分类
 */
export function saveCourseCollect(data) {
  return request({
    url: '/yunxue_co_api/course/saveCourseCollect',
    method: 'get',
    params: data,
    isJson: true
  })
}


/**
 * 用户是否选择兴趣接口
 */
export function getSecollect(data) {
  return request({
    url: '/yunxue_co_api/login/getSecollect',
    method: 'get',
    params: data,
    isJson: true
  })
}

/**
 * 学习报告
 */
export function getTimePai(data) {
   return request({
    url: '/yunxue_co_api/user/getTimeRank',
    method: 'get',
    params: data,
    isJson: true
  })
}

/**
 * 公告的接口
 */
export function getAllNotice(data) {
   return request({
    url: '/yunxue_co_api/notice/getAllNotice',
    method: 'get',
    params: data,
    isJson: true
  })
}

export function getNoticeDetail(data) {
   return request({
    url: '/yunxue_co_api/notice/getNotice',
    method: 'get',
    params: data,
    isJson: true
  })
}


/**
 * 获取直播列表
 * 
 */
 export function getLives(data) {
  return request({
    url: '/yunxue_co_api/live/getLiveInfo',
    method: 'get',
    params: data,
    isJson: true,
    noAuth: true
  })
}

/**

 * 获取微课详情
 * 
 */
 export function getLiveDetail(data) {
  return request({
    url: '/yunxue_co_api/live/getLiveMessage',
    method: 'get',
    params: data,
    isJson: true,
    noAuth: true
  })
}

/**
 * 获取课程评论
 * 0-课程，2-语音微课，3-视频微课，4-学习计划
 */
 export function getLiveDanmus(data) {
      return request({
        url: '/yunxue_co_api/Feel/getFeelList',
        method: 'get',
        params: data,
        isJson: true,
        noAuth: true
      })
    }
  
  /**
   * 发送课程评论
   */
   export function saveCourseComments(data) {
    return request({
      url: '/yunxue_co_api/Feel/saveFeelInfo',
      method: 'get',
      params: data,
      noAuth: true
    })
  }

  /**
 * 获取直播在线情况人员列表
 */
export function getLiveStateList(data) {
  return request({
    url: '/yunxue_co_api/live/getOnAndOffLineUsers/'+data.audioId,
    method: 'get',
    params: data,
    noAuth: true
  })
}


/**
 * 最新课程列表
 */

export function getClassData(data) {
  return request({
    url: '/yunxue_co_api/course/getCourseList',
    method: 'get',
    params: data,
    isJson: true,
    noAuth: true
  })
}


/**
 * 任务列表
 */
export function getHomeData(data) {
  return request({
    url: '/yunxue_co_api/systemConfig/getMainMessage',
    method: 'get',
    params: data,
    isJson: true,
    noAuth: true
  })
}


/**
 * 提交观看时长
 */
 export function addWatchClassH(data) {  
   return request.post('/yunxue_co_api/course/addWatchClass', data, {
		 isJson: true
	});
}


/**
 * 上报阅读状态
 */
 export function addReadStatus(data) {
  return request({
    url: '/yunxue_co_api/document/readStatus',
    method: 'get',
    params: data,
    isJson: true
  })
}


/**
 * 消息
 */
 export function getMessageList(data) {
  return request({
    url: '/yunxue_co_api/msg/getNewMessage',
    method: 'get',
    params: data,
    isJson: true
  })
}


/**
 * 帮助中心
 */
 export function getHelpList(data) {
  return request({
    url: '/yunxue_co_api/systemConfig/getHelpCenterList',
    method: 'get',
    params: data,
    isJson: true
  })
}


/**
 * 帮助中心详情
 */
 export function getHelpDetail(data) {
  return request({
    url: '/yunxue_co_api/systemConfig/getHelpCenterDetail',
    method: 'get',
    params: data,
    isJson: true
  })
}

/**
 * 记录直播进入和退出，观看者进入直播时和退出直播（包含直播结束退出）时调用该接口
 */
 export function recordinout(data) {
    return request({ 
      url: '/yunxue_co_api/live/recordinout/'+data.liveid+'/'+data.memberId+'/'+data.type,
      method: 'get',
      isJson: true
    })
  }

  
/**
 * 帮助中心详情
 */
 export function gettext(data) {
  return request({
    url: 'yunxue_app_api/user/gettext/16',
    method: 'get',
    params: data,
    isJson: true
  })
}


/**
 * 企业智库
 */
export function getCourseList(data) {
  return request({
    url: '/yunxue_co_api/course/getCourseList',
    method: 'get',
    params: data,
    isJson: true
  })
}

/**
 * 企业智库分类
 */
export function getCourseType(data) {
  return request({
    url: '/yunxue_co_api/course/getCourseType',
    method: 'get',
    params: data,
    isJson: true
  })
}



/**
 *任务接口
 */
 export function getStudyTask(data) {
  return request({
    url: '/yunxue_co_api/task/getStudyTask',
    method: 'get',
    params: data,
    isJson: true
  })
}


/**
 *任务详情
 */
 export function getTaskInfo(data) {
  return request({
    url: '/yunxue_co_api/task/getTaskInfo',
    method: 'get',
    params: data,
    isJson: true
  })
}

/**
 * 获取观看课程列表
 */
 export function getCourseMessage(data) {
  return request({
    url: '/yunxue_co_api/course/getCourseMessage',
    method: 'get',
    params: data,
    isJson: true
  })
}


/**
 *考试答题卡
 */
 export function getExamCard(data) {
  return request({
    url: '/yunxue_co_api/Exam/getExamCard',
    method: 'get',
    params: data,
    isJson: true
  })
}


/**
 *考试交卷
 */
 export function saveAllAnswer(data) {
  return request({
    url: '/yunxue_co_api/Exam/saveAllAnswer',
    method: 'get',
    params: data,
    isJson: true
  })
}

/**
 *获取文件信息GET 
 */
 export function getFile(data) {
  return request({
    url: '/yunxue_co_api/document/getFile',
    method: 'get',
    params: data,
    isJson: true
  })
}


/**
 *考试详情
 */
 export function getExamInfo(data) {
  return request({
    url: '/yunxue_co_api/Exam/getExamInfo',
    method: 'get',
    params: data,
    isJson: true
  })
}


/**
 *获取学习历史
 */
 export function getStudyHistory(data) {
  return request({
    url: '/yunxue_co_api/task/getStudyHistory',
    method: 'get',
    params: data,
    isJson: true
  })
}
/*
获取课程评论列表
 */

 export function getFeelList(data) {
    return request({
      url: '/yunxue_co_api/Feel/getFeelList',
      method: 'get',
      params: data,
      isJson: true,
      noAuth: true
    })
  }
  
  /*
  添加课程评论
   */
  
  export function addClassComment(data) {
    return request({
      url: '/yunxue_co_api/Feel/saveFeelInfo',
      method: 'get',
      params: data,
      isJson: true,
      noAuth: true
    })
  }



  /*
 测评
 */

 export function fieldSave(data) {
    return request({
      url: '/yunxue_co_api/field/save',
      method: 'get',
      params: data,
      isJson: true,
      noAuth: true
    })
  }


// WEBPACK FOOTER //
// ./src/api/api.js